import { useContext } from "react";
import { SessionContext } from "./context";

export function useSessionProvider() {
  const context = useContext(SessionContext);
  if (context === undefined) {
    throw new Error("useSession must be used within a PermissionsProvider");
  }
  return context;
}

export const myAuthClient = {
  useSessionProvider,
};
